/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import { Anchor } from '@mantine/core';
import { Link } from 'react-router-dom';
import AppStack from '../../../../common/AppStack';
import AppText from '../../../../common/AppText';
import { ECOM_WEBSTORE_PAGE_TYPE_ENUM } from '../../../../../config/constants';
import { generateColorVariants } from '../../../../../helpers/styles';
import AppFlexbox from '../../../../common/AppFlexbox';
import {
  determineEcomStoreMenuItemUrl,
  getWebstoreSubHeadingSize
} from '../../../../../helpers/webstoreHelper';

const defaultHeaderMenu = {
  pkEcomStoreMenu: 0,
  title: 'Default',
  ecomStoreMenuItems: [
    {
      pkEcomStoreMenuItem: 1,
      title: 'Products',
      customUrl: '',
      sort: 1,
      ecomResourceId: null,
      fkEcomStoreMenuItem: null,
      fkEcomStorePageType: ECOM_WEBSTORE_PAGE_TYPE_ENUM.PRODUCT
    }
  ]
};

const WsMenuBlock = ({
  config,
  colorScheme,
  ecomStoreMenus,
  ecomStoreTheme,
  baseStoreUrl,
  onNavigate
}) => {
  const selectedMenu =
    ecomStoreMenus.find(
      (menu) =>
        menu.pkEcomStoreMenu.toString() === config.ecomStoreMenu?.toString()
    ) ??
    ecomStoreMenus.sort(
      (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
    )[0] ??
    defaultHeaderMenu;
  const textColorVariants = generateColorVariants(colorScheme.textColor, 100);

  return (
    <AppFlexbox>
      <AppStack>
        {config.heading && (
          <AppText
            style={{
              fontWeight: 500,
              fontSize: getWebstoreSubHeadingSize(config.headingSize),
              wordBreak: 'break-word',
              overflowWrap: 'break-word'
            }}
          >
            {config.heading}
          </AppText>
        )}
        <AppStack style={{ gap: 8 }}>
          {selectedMenu &&
            selectedMenu.ecomStoreMenuItems.map((i) => {
              const urlInfo = determineEcomStoreMenuItemUrl({
                ...i,
                ecomStoreTheme
              });

              return (
                <Anchor
                  key={i.pkEcomStoreMenuItem}
                  component={Link}
                  onClick={(e) => onNavigate(e)}
                  style={{ fontSize: 14, color: textColorVariants.lighter }}
                  target={urlInfo.target}
                  to={urlInfo.url || `${baseStoreUrl ?? ''}${urlInfo.path}`}
                >
                  {i.title}
                </Anchor>
              );
            })}
        </AppStack>
      </AppStack>
    </AppFlexbox>
  );
};

WsMenuBlock.propTypes = {
  baseStoreUrl: PropTypes.string,
  colorScheme: PropTypes.object,
  config: PropTypes.object,
  ecomStoreMenus: PropTypes.array,
  ecomStoreTheme: PropTypes.object,
  onNavigate: PropTypes.func
};

export default WsMenuBlock;
